import { theme } from "antd";
import { PHONE_MAX_WIDTH, TABLET_MAX_WIDTH } from "./breakpoints";
import { COLOR_VARIATIONS, CUSTOM_COLORS } from "./colorUtils";

/** App-wide UI font (matches GlobalStyle / index.css) */
const POPPINS_STACK =
	"'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const antdTheme = {
	algorithm: theme.defaultAlgorithm,
	token: {
		fontFamily: POPPINS_STACK,

		// Align antd's responsive breakpoints with ours: "below md" is the phone
		// layout and "below lg" is the tablet layout (see breakpoints.ts).
		screenMD: PHONE_MAX_WIDTH + 1,
		screenLG: TABLET_MAX_WIDTH + 1,

		colorPrimary: COLOR_VARIATIONS.primary.main,
		colorPrimaryHover: COLOR_VARIATIONS.primary.hover,
		colorPrimaryActive: COLOR_VARIATIONS.primary.active,
		colorPrimaryBg: COLOR_VARIATIONS.primary.light,
		colorPrimaryBgHover: "#E5E0F5",
		colorPrimaryBorder: "#D4CCF0",
		colorPrimaryBorderHover: "#C4BAEB",
		colorPrimaryText: "#3A0CA3",
		colorPrimaryTextHover: "#4A1CB3",
		colorPrimaryTextActive: "#2A0C93",

		// Secondary color (using as accent)
		colorInfo: "#4460EF",
		colorInfoHover: "#5470FF",
		colorInfoActive: "#3450DF",
		colorInfoBg: "#F0F3FF",
		colorInfoBgHover: "#E5EBFF",
		colorInfoBorder: "#D4E0FF",
		colorInfoBorderHover: "#C4D6FF",
		colorInfoText: "#4460EF",
		colorInfoTextHover: "#5470FF",
		colorInfoTextActive: "#3450DF",

		// Custom color tokens for your specific colors
		colorCustomPink: CUSTOM_COLORS.PINK,
		colorCustomLightBlue: CUSTOM_COLORS.LIGHT_BLUE,
	},
};
